import { Box, Portal } from '@chakra-ui/react';
import React from 'react';
import ColorMenu from "../components/Navbars/ColorMenuNavbar";


export default function Menu() {
    // Chakra Color Mode
    return (
        <>
            <Box
                w={{ base: '100%', xl: 'calc(100% - 275px)' }}
                float={'right'} maxW = "100%" maxH="100%" overflow="auto" pos="relative"
            >
                <Portal>
                    <ColorMenu logoText={'SURELLE DASHBOARD'} />
                </Portal>
            </Box>
        </>
    );
}
